// This is a placeholder during development
// and may be replaced during build by a vite plugin.
export const additionalRemoteOrigins = [];
